<h2 mat-dialog-title>
  {{ 'SHARE.TITLE' | translate }}
</h2>
<mat-dialog-content>
  <div class="dialog-content">
    @if (namespaceName$ | async; as namespaceName) {
      @if (changingPrivacyLevel) {
        <div class="stencil-shimmer"></div>
        <div class="stencil-shimmer"></div>
        <div class="stencil-shimmer"></div>
      } @else {
        <glxy-form-field>
          <glxy-label>{{ 'VISIBILITY.MEETING_VISIBILITY_V2' | translate }}</glxy-label>
          <mat-select [(ngModel)]="selectedPrivacyLevel" (selectionChange)="onPrivacyLevelChange($event.value)">
            <mat-option [value]="PrivacyLevel.PRIVACY_LEVEL_OPEN">
              {{ 'VISIBILITY.OPEN' | translate: { namespaceName: namespaceName } }}
            </mat-option>
            <mat-option [value]="PrivacyLevel.PRIVACY_LEVEL_UNLISTED">
              {{ 'VISIBILITY.UNLISTED_V2' | translate: { namespaceName: namespaceName } }}
            </mat-option>
            <mat-option [value]="PrivacyLevel.PRIVACY_LEVEL_PRIVATE">
              {{ 'VISIBILITY.PRIVATE' | translate }}
            </mat-option>
          </mat-select>
          <glxy-hint>@if (selectedPrivacyLevel === PrivacyLevel.PRIVACY_LEVEL_OPEN) {
            {{ 'VISIBILITY.VISIBILITY_DESCRIPTION.OPEN' | translate: { namespaceName: namespaceName } }}
          } @else if (selectedPrivacyLevel === PrivacyLevel.PRIVACY_LEVEL_UNLISTED) {
            {{ 'VISIBILITY.VISIBILITY_DESCRIPTION.UNLISTED' | translate: { namespaceName: namespaceName } }}
          } @else if (selectedPrivacyLevel === PrivacyLevel.PRIVACY_LEVEL_PRIVATE) {
            {{ 'VISIBILITY.VISIBILITY_DESCRIPTION.PRIVATE' | translate: { namespaceName: namespaceName } }}
          }</glxy-hint>
        </glxy-form-field>
        <mat-tab-group class="share-link-tabs" animationDuration="0ms">
        <mat-tab>
          <ng-template mat-tab-label>
            {{ 'SHARE.INTERNAL_LINK_TAB' | translate }}
          </ng-template>
          <div class="share-tab-body">
            <glxy-form-field bottomSpacing="none">
              <input matInput type="text" [value]="url" readonly tabIndex="-1" [disabled]="true" />
              <button
                class="suffix-button"
                mat-flat-button
                color="primary"
                (click)="copyInternalLink()"
                matSuffix
                >
                <mat-icon>link</mat-icon>
                {{ 'COMMON.COPY_LINK' | translate }}
              </button>
            </glxy-form-field>
            <p class="share-url-hint">{{ 'SHARE.INTERNAL_LINK_HINT' | translate }}</p>
            <glxy-form-field>
              <mat-checkbox
                tabIndex="-1"
                [checked]="atCurrentTime()"
                (change)="onAtCurrentTimeChange($event.checked)"
                >
                @if (currentTimestamp() < 1) {
                  {{ 'SHARE.AT_BEGINNING' | translate }}
                } @else {
                  {{ 'SHARE.AT_CURRENT_TIME' | translate }}
                  @if (currentTimestamp() < hourInSeconds) {
                    {{ currentTimestamp() | secondsToDateSeconds | date: 'mm:ss' }}
                  } @else {
                    {{ currentTimestamp() | secondsToDateSeconds | date: 'hh:mm:ss' }}
                  }
                }
              </mat-checkbox>
            </glxy-form-field>
          </div>
        </mat-tab>
        <mat-tab>
          <ng-template mat-tab-label>
            <span class="share-external-tab-label">
              {{ 'SHARE.EXTERNAL_LINK_TAB' | translate }}
              @if (externalShareEnabled()) {
                <mat-icon class="external-link-tab-icon">check_circle</mat-icon>
              }
            </span>
          </ng-template>
          <div class="share-tab-body">
            @if (externalShareEnabled()) {
              <div class="external-link-panel external-link-panel--active">
                <div class="external-link-panel__copy">
                  <p class="external-link-panel__title">{{ 'SHARE.EXTERNAL_LINK_ON_TITLE' | translate }}</p>
                  <p class="external-link-panel__description">{{ 'SHARE.EXTERNAL_LINK_ON_DESCRIPTION' | translate }}</p>
                </div>
                <mat-slide-toggle
                  class="external-link-panel__toggle"
                  [checked]="externalShareEnabled()"
                  (change)="onExternalShareToggle($event.checked)"
                  />
              </div>
              <glxy-form-field bottomSpacing="none">
                <input
                  matInput
                  type="text"
                  [value]="externalShareUrl()"
                  readonly
                  tabIndex="-1"
                  [disabled]="true"
                  />
                <button
                  class="suffix-button"
                  mat-flat-button
                  color="primary"
                  (click)="copyExternalLink()"
                  matSuffix
                  [disabled]="!externalShareUrl()"
                  >
                  <mat-icon>link</mat-icon>
                  {{ 'COMMON.COPY_LINK' | translate }}
                </button>
              </glxy-form-field>
              <p class="share-url-hint">{{ 'SHARE.EXTERNAL_LINK_HINT' | translate }}</p>
              <glxy-form-field>
                <mat-checkbox
                  tabIndex="-1"
                  [checked]="atCurrentTime()"
                  (change)="onAtCurrentTimeChange($event.checked)"
                  >
                  @if (currentTimestamp() < 1) {
                    {{ 'SHARE.AT_BEGINNING' | translate }}
                  } @else {
                    {{ 'SHARE.AT_CURRENT_TIME' | translate }}
                    @if (currentTimestamp() < hourInSeconds) {
                      {{ currentTimestamp() | secondsToDateSeconds | date: 'mm:ss' }}
                    } @else {
                      {{ currentTimestamp() | secondsToDateSeconds | date: 'hh:mm:ss' }}
                    }
                  }
                </mat-checkbox>
              </glxy-form-field>
            } @else {
              <div class="external-link-panel">
                <div class="external-link-panel__copy">
                  <p class="external-link-panel__title">{{ 'SHARE.EXTERNAL_LINK_CARD_TITLE' | translate }}</p>
                  <p class="external-link-panel__description">{{ 'SHARE.EXTERNAL_LINK_CARD_DESCRIPTION' | translate }}</p>
                </div>
                <mat-slide-toggle
                  class="external-link-panel__toggle"
                  [checked]="externalShareEnabled()"
                  (change)="onExternalShareToggle($event.checked)"
                  />
              </div>
            }
          </div>
        </mat-tab>
      </mat-tab-group>
      }
    }
  </div>
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-stroked-button mat-dialog-close tabIndex="-1">
    {{ 'COMMON.CLOSE' | translate }}
  </button>
</mat-dialog-actions>
